import React from 'react';
import makeStyles from '@mui/styles/makeStyles';
import cn from 'classnames';
import SectionDividers from '@dyl/components/SectionDividers';
import { times } from 'lodash';
import useTaskField from '@dyl/pages/Tasks/edit/useTaskField';

const useStyles = makeStyles(theme => ({
    root: {
        maxWidth: theme.breakpoints.values.md,
    },
}));

/**
 * @typedef Props
 * @property {React.ComponentType<{ index: number }>} itemComponent
 * @property {JSX.Element} [before]
 * @property {JSX.Element} [after]
 */

/**
 * @param {Props & React.HTMLAttributes<HTMLDivElement>} props
 */
export default function TaskItems({
    itemComponent: Item,
    className: propsClass,
    before = null,
    after = null,
    ...other
}) {
    const classes = useStyles();
    const [items] = useTaskField('items');

    return (
        <div className={cn(classes.root, propsClass)} {...other}>
            <SectionDividers>
                {before}
                {times(items.length, i => <Item key={i} index={i} />)}
                {after}
            </SectionDividers>
        </div>
    );
}